export enum TimeRange {
  Week = "Week",
  Month = "Month",
  Quarter = "Quarter",
  Other = "Other",
}
